// extracted by mini-css-extract-plugin
export var indexBody = "index-module--indexBody--Z5QHn";
export var tool = "index-module--tool--3iw86";
export var pc = "index-module--pc--1FkwN";